const routes = [
    {
        path: '/orderList',
        name: 'orderList',
        component: () =>
            import('../../components/page/orderList/orderList.vue'),
        meta: { title: '订单列表' }
    },
    {
        path: '/refundList',
        name: 'refundList',
        component: () =>
            import('../../components/page/orderList/refundList.vue'),
        meta: { title: '退款列表' }
    },
    {
        path: '/voucherList',
        name: 'voucherList',
        component: () =>
            import('../../components/page/voucherList/voucherList.vue'),
        meta: { title: '兑换列表' }
    },
    {
        path: '/userList',
        name: 'userList',
        component: () =>
            import('../../components/page/userList/userList.vue'),
        meta: { title: '用户列表' }
    },
    {
        path: '/searchList',
        name: 'searchList',
        component: () =>
            import('../../components/page/searchList/searchList.vue'),
        meta: { title: '搜索记录列表' }
    },
    {
        path: '/prizeList',
        name: 'prizeList',
        component: () =>
            import('../../components/page/prizeList/prizeList.vue'),
        meta: { title: '抽奖记录' }
    },
    {
        path: '/footPrintList',
        name: 'footPrintList',
        component: () =>
            import('../../components/page/footPrintList/footPrintList.vue'),
        meta: { title: '活跃用户列表' },
    }, {
        path: '/footPrintList/detail',
        name: 'footPrintList/detail',
        component: () =>
            import('../../components/page/footPrintList/detail.vue'),
        meta: { title: '活跃用户列表详情页' },
    }, {
        path: '/dashboard',
        name: 'dashboard',
        component: () =>
            import('../../components/page/dashboard/dashboard.vue'),
        meta: { title: '首页-统计' },
    },
    {
        path: '/chooseScenic',
        name: 'chooseScenic',
        component: () =>
            import('../../components/page/chooseScenic/chooseScenic.vue'),
        meta: { title: '选择景区' },
    },
    {
        path: '/manageList',
        name: 'manageList',
        component: () =>
            import('../../components/page/manage/userList.vue'),
        meta: { title: '用户列表' },
    },
    {
        path: '/createUser',
        name: 'createUser',
        component: () =>
            import('../../components/page/manage/createUser.vue'),
        meta: { title: '创建角色' },
    },
    {
        path: '/scenicList',
        name: 'scenicList',
        component: () =>
            import('../../components/page/manage/scenicList.vue'),
        meta: { title: '创建项目' },
    },
    {
        path: '/createAdmin',
        name: 'createAdmin',
        component: () =>
            import('../../components/page/manage/createAdmin.vue'),
        meta: { title: '创建管理员' },
    },
    {
        path: '/createAdmin2',
        name: 'createAdmin2',
        component: () =>
            import('../../components/page/manage/createAdmin2.vue'),
        meta: { title: '创建管理员' },
    },
    {
        path: '/bindWeChat',
        name: 'bindWeChat',
        component: () =>
            import('../../components/page/bindWeChat/bindWeChat.vue'),
        meta: { title: '渠道运营信息列表' },
    },
    {
        path: '/totalData',
        name: 'totalData',
        component: () =>
            import('../../components/page/totalData/totalData.vue'),
        meta: { title: '收入统计' },
    },
    {
        path: '/projectTotalData',
        name: 'projectTotalData',
        component: () =>
            import('../../components/page/totalData/projectTotalData.vue'),
        meta: { title: '收入统计' },
    },
    {
        path: '/subdivisionLog',
        name: 'subdivisionLog',
        component: () =>
            import('../../components/page/subdivisionLog/subdivisionLog.vue'),
        meta: { title: '分账日志' },
    },
    {
        path: '/financialStatistics',
        name: 'financialStatistics',
        component: () =>
            import('../../components/page/financialStatistics/financialStatistics.vue'),
        meta: { title: '财务统计' },
    },
    {
        path: '/newFinancialStatistics',
        name: 'newFinancialStatistics',
        component: () =>
            import('../../components/page/financialStatistics/newFinancialStatistics.vue'),
        meta: { title: '财务统计分析' },
    },
    {
        path: '/behavioralStatistics',
        name: 'behavioralStatistics',
        component: () =>
            import('../../components/page/behavioralStatistics/behavioralStatistics.vue'),
        meta: { title: '行为统计' },
    },
    {
        path: '/channelStatistics',
        name: 'channelStatistics',
        component: () =>
            import('../../components/page/channelStatistics/channelStatistics.vue'),
        meta: { title: '渠道统计' },
    },
    {
        path: '/faceTransplant',
        name: 'faceTransplant',
        component: () =>
            import('../../components/page/manage/faceTransplant.vue'),
        meta: { title: 'AI换脸模板' },
    },
]


export default routes;


// WEBPACK FOOTER //
// ./src/router/projectRouter/index.js